import { SkeletonButton } from 'x-ui-design';

export const LeftSidebarFavoriteSkeleton = () => {
  return (
    <SkeletonButton style={{ width: '100%', height: 48, marginBottom: 4 }} />
  );
};
